import { Model } from '@vuex-orm/core'

export default class LtmHasRoomtypeHasRoomltm extends Model{
  static entity = 'ltmHasRoomtypeHasRoomltms'
  static fields () {
    return {
      id: this.number(null),
      ltms_id: this.number(null),
      roomltms_id: this.number(null),
      roomtypes_id: this.number(null),
      window: this.boolean(false),
      default: this.boolean(false),
    }
  }
}
  